import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	getNotifications,
} from "../../../redux/actions/authActions";
import { getAllAlerts } from "../../../redux/actions/authActions";
import { getAllEvents } from "../../../redux/actions/authActions";
import { Modal } from "antd";
import { AiOutlineEye } from "react-icons/ai";
import dayjs from "dayjs";
import {
	getAllCompliances,
} from "../../../redux/actions/authActions";

const indianStates = [
	"Andhra Pradesh",
	"Arunachal Pradesh",
	"Assam",
	"Bihar",
	"Chhattisgarh",
	"Goa",
	"Gujarat",
	"Haryana",
	"Himachal Pradesh",
	"Jharkhand",
	"Karnataka",
	"Kerala",
	"Madhya Pradesh",
	"Maharashtra",
	"Manipur",
	"Meghalaya",
	"Mizoram",
	"Nagaland",
	"Odisha",
	"Punjab",
	"Rajasthan",
	"Sikkim",
	"Tamil Nadu",
	"Telangana",
	"Tripura",
	"Uttar Pradesh",
	"Uttarakhand",
	"West Bengal",
	"Andaman and Nicobar Islands",
	"Chandigarh",
	"Dadra and Nagar Haveli and Daman and Diu",
	"Delhi",
	"Lakshadweep",
	"Puducherry",
];

const NotificationHome = () => {
	const dispatch = useDispatch();

	// Redux selectors
	const { notifications = [] } = useSelector(state => state.auth);
	const { compliances: allCompliances = [] } = useSelector(state => state.auth);

	// Local state
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalEvent, setModalEvent] = useState(null);
	const [isCompModalOpen, setIsCompModalOpen] = useState(false);
	const [modalComp, setModalComp] = useState(null);
	const [unDueCompliances, setUnDueCompliances] = useState([]);
	const [modalNotification, setModalNotification] = useState(null);
	const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);

	// State for the selected state filter, shared between both lists
	const [selectedState, setSelectedState] = useState("All States");

	// Fetch data on mount
	useEffect(() => {
		dispatch(getNotifications());
		dispatch(getAllAlerts());
		dispatch(getAllEvents());
		dispatch(getAllCompliances());
	}, [dispatch]);

	// Set overdue compliances based on allCompliances and selectedState
	useEffect(() => {
		const stateFilteredCompliances =
			selectedState === "All States"
				? allCompliances
				: allCompliances.filter(
					(c) => c.state === selectedState || c.state === "All States"
				);

		const unDueComps = stateFilteredCompliances.filter((c) => {
			return c.dueDate === null;
		});
		setUnDueCompliances(unDueComps);
	}, [allCompliances, selectedState]);


	// Filter active notifications
	const activeNotifications = notifications.filter((n) => n.status === true);
	
	// Handlers
		const handleCancel = () => {
		setIsModalOpen(false);
		setModalEvent(null);
	};

	const handleCancelComp = () => {
		setIsCompModalOpen(false);
		setModalComp(null);
	};

	const handleNotificationClick = (n) => {
		setModalNotification(n);
		setIsNotificationModalOpen(true);
	};

	const handleNotificationModalClose = () => {
		setModalNotification(null);
		setIsNotificationModalOpen(false);
	};

	
	const handleCompClick = (event) => {
		setModalComp(event);
		setIsCompModalOpen(true);
	};

	
	return (
		<div className="p-6 md:p-12 bg-gray-50 min-h-screen">
			{/* Marquee */}
			{/* <MarqueeNotification alerts={activeAlerts} /> */}
			{/* Main Content Sections */}
			<div className="grid grid-cols-1 md:grid-cols-2 gap-8 my-8 ">
				{/* Notifications Card */}
				<div className="bg-white rounded-xl shadow-lg p-6 flex flex-col h-full max-h-screen ">
					<h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
						Notifications
					</h2>
					<div className="flex-1 space-y-4 overflow-y-auto pr-2">
						{activeNotifications.length === 0 ? (
							<p className="text-gray-500 text-center py-8">
								No active notifications available.
							</p>
						) : (
							activeNotifications.map((n) => (
								<div
									key={n._id}
									className="bg-gray-100 rounded-lg p-4 cursor-pointer hover:bg-blue-50 transition-colors duration-200"
									onClick={() => handleNotificationClick(n)}
								>
									<div className="flex justify-between items-start">
										<div className="text-base font-semibold text-gray-900 leading-tight">
											{n.title}
										</div>
										<AiOutlineEye
											className="text-gray-500 hover:text-blue-600 transition-colors"
											size={20}
										/>
									</div>
									<p className="text-sm text-gray-600 mt-1 line-clamp-2">
										{n.description}
									</p>
									<div className="text-xs text-gray-400 mt-2">
										{dayjs(n.createdAt).format("DD MMM YYYY")}
									</div>
								</div>
							))
						)}
					</div>
				</div>

				{/* Undue Compliances Card (with new filter) */}
				<div className="bg-white rounded-xl shadow-lg p-6 flex flex-col h-full max-h-screen">
					<div className="flex justify-between items-center mb-4 border-b pb-2">
						<h2 className="text-2xl font-bold text-gray-800">
							Undue Compliances
						</h2>
						<div className="flex items-center">
							<label htmlFor="state-filter" className="sr-only">
								Filter by State
							</label>
							<select
								id="state-filter"
								value={selectedState}
								onChange={(e) => setSelectedState(e.target.value)}
								className="form-select block w-full pl-3 pr-10 py-1.5 text-base text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
							>
								<option value="All States">All States</option>
								{indianStates.map((state) => (
									<option key={state} value={state}>
										{state}
									</option>
								))}
							</select>
						</div>
					</div>
					<div className="flex-1 space-y-4 overflow-y-auto pr-2">
						{unDueCompliances.length === 0 ? (
							<p className="text-gray-500 text-center py-8">
								No undue compliances found.
							</p>
						) : (
							unDueCompliances.map((comp) => (
								<div
									key={comp._id}
									className="bg-gray-100 rounded-lg p-4 flex justify-between items-start cursor-pointer hover:bg-red-50 transition-colors duration-200"
									onClick={() => handleCompClick(comp)}
								>
									<div>
										<div className="text-sm font-semibold">{comp.act}</div>
										<p className="text-xs text-gray-600 mt-1 line-clamp-2">
											{comp.state}
										</p>
									</div>
									<AiOutlineEye className="text-gray-500 hover:text-red-600 transition-colors" />
								</div>
							))
						)}
					</div>
				</div>
			</div>
			{/* Calendar Section
      <h2 className="text-2xl font-bold text-gray-800 my-8">Calendar</h2> */}

			{/* Modals remain unchanged */}
			<Modal
				title="Notification Details"
				open={isNotificationModalOpen}
				onCancel={handleNotificationModalClose}
				footer={null}
				destroyOnClose
			>
				{modalNotification && (
					<div>
						<h3 className="text-lg font-semibold mb-2">
							{modalNotification.title}
						</h3>
						<p className="mb-2">{modalNotification.description}</p>
						<p className="text-sm text-gray-600">
							Date: {new Date(modalNotification.createdAt).toDateString()}
						</p>
						{modalNotification.document && (
							<a
								className="text-blue-500 mt-2 inline-block"
								href={modalNotification.document}
								target="_blank"
								rel="noopener noreferrer"
							>
								View Document
							</a>
						)}
					</div>
				)}
			</Modal>
			<Modal
				title="Event Details"
				open={isModalOpen}
				onCancel={handleCancel}
				footer={null}
				destroyOnClose
			>
				{modalEvent && (
					<div>
						<h3 className="text-lg font-semibold mb-2">{modalEvent.name}</h3>
						<p className="mb-2">{modalEvent.description}</p>
						<p className="text-sm text-gray-600">
							Date: {new Date(modalEvent.date).toDateString()}
						</p>
						{modalEvent.document && (
							<a
								className="text-blue-500 mt-2 inline-block"
								href={modalEvent.document}
								target="_blank"
								rel="noopener noreferrer"
							>
								View Document
							</a>
						)}
					</div>
				)}
			</Modal>
			<Modal
				title="Compliance Details"
				open={isCompModalOpen}
				onCancel={handleCancelComp}
				footer={null}
				destroyOnClose
			>
				{modalComp && (
					<div>
						<h3 className="text-lg font-semibold mb-2">{modalComp.act}</h3>
						<p className="mb-2">{modalComp.description}</p>
						<p className="mb-2">State : {modalComp.state}</p>
						<p className="mb-2">Act-Type : {modalComp.actType}</p>
						<p className="mb-2">
							Remittance / Return : {modalComp["remittance/Return"]}
						</p>
						<p className="mb-2">Type of return : {modalComp.typeOfReturn}</p>
						<p className="mb-2">Remarks : {modalComp.remarks1 || "None"} </p>

						<p className="text-sm text-gray-600">
							Due Date: {new Date(modalComp.dueDate).toDateString()}
						</p>
					</div>
				)}
			</Modal>
		</div>
	);
};

export default NotificationHome;
